<div class="container px-lg-0">
  <!--Back Button-->
  <div class="pt-3 d-none d-lg-block">
    <div class="back-btn text-white cursor-pointer" [routerLink]="'/rewards/raffles'">
      <span class="material-icons"> arrow_back_ios </span>
    </div>
  </div>
  <!--Point Summary Bar-->
</div>
<fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'" [backButtonTitle]="'Raffles'"></fgb-points-summary-bar>
<!--Lotto Details-->
<fgbcl-lotto-details-v2 [lottoId]="id" />
